'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoArrowDownC = function IoArrowDownC(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.2 25.2l-8.2 7.8c-0.5 0.5-1.1 0.8-1.8 0.8s-1.2-0.3-1.7-0.8l-8.3-7.8c-0.9-0.9-0.9-2.4 0-3.3s2.7-1 3.6 0l3.9 3.7v-16.9c0-1.4 1.1-2.4 2.5-2.4s2.5 1 2.5 2.4v16.9l3.9-3.7c0.9-1 2.7-1 3.6 0s0.9 2.4 0 3.3z' })
        )
    );
};

exports.default = IoArrowDownC;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/arrow-down-c.js
// module id = 2415
// module chunks = 168707334958949